// extracted by mini-css-extract-plugin
export default {"containerCardSecure":"styles_containerCardSecure__QESJ5","cardSecure":"styles_cardSecure__xD0X1"};